import * as React from "react"

function useControlledInput(initalState: any) {
	const [state, setState] = React.useState(initalState)

	function onChange(event: React.ChangeEvent<HTMLInputElement>) {
		setState(event.target.value)
	}

	return [state, onChange, setState]
}

export default useControlledInput
